import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["onClick"]

import { CssColours } from '@/static/colours'

/**
 * Subset of CSS properties - just two properties that are required
 */
interface backgroundColorOption {
  name: string
  color: string
}

/**
 * Font background available styles
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'FontBackgroundSelector',
  props: {
    selectedFontBackgroundColor: null,
    disabled: { type: Boolean }
  },
  emits: ["fontBackgroundColorSelected"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'fontBackgroundColorSelected', backgroundColor: string): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  selectedFontBackgroundColor: string | null,
  disabled: boolean
};

const backgroundColors: backgroundColorOption[] = [
  {
    name: 'transparent',
    color: CssColours.TRANSPARENT
  },
  {
    name: 'black',
    color: CssColours.BLACK
  },
  {
    name: 'white',
    color: CssColours.WHITE
  }
]






return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['font-background-selector', { 'font-background-selector--disabled': __props.disabled }])
  }, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(backgroundColors, (backgroundColor, index) => {
      return _createElementVNode("div", {
        key: index,
        class: _normalizeClass([
        'font-background-selector__item',
        {
          'font-background-selector__item--selected': backgroundColor.color === __props.selectedFontBackgroundColor
        }
      ]),
        onClick: ($event: any) => (emits('fontBackgroundColorSelected', backgroundColor.color))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(['font-background-selector__item-contents', `font-background-selector__item-contents--${backgroundColor.name}`])
        }, " Aa ", 2)
      ], 10, _hoisted_1)
    }), 64))
  ], 2))
}
}

})